import { render, staticRenderFns } from "./classifyTree.vue?vue&type=template&id=4365733c&scoped=true"
import script from "./classifyTree.vue?vue&type=script&lang=js"
export * from "./classifyTree.vue?vue&type=script&lang=js"
import style0 from "./classifyTree.vue?vue&type=style&index=0&id=4365733c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4365733c",
  null
  
)

export default component.exports